import { CustomSearchParams } from "@/components/common/deep-link/deep-link-encoding";
import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

/**
 * Checks if the viewer was opened from WebEditor by looking for the special marker parameter.
 * Reports the redirect once and then drops the marker from the url, so that reloading or sharing
 * it does not greet the user again.
 *
 * @returns true if the viewer was opened through a redirect from the HoloBuilder WebEditor
 */
export function useWasOpenedFromWebEditor(): boolean {
  const [searchParams, setSearchParams] = useSearchParams();
  const { state } = useLocation();
  const [wasOpenedFromWebEditor] = useState(() =>
    searchParams.has(CustomSearchParams.hbRedirect),
  );

  useEffect(() => {
    if (!searchParams.has(CustomSearchParams.hbRedirect)) return;

    setSearchParams(
      (params) => {
        params.delete(CustomSearchParams.hbRedirect);
        return params;
      },
      { replace: true, state },
    );
  }, [searchParams, setSearchParams, state]);

  return wasOpenedFromWebEditor;
}
